export default __webpack_public_path__ + "static/media/favicon-mt.f26d0589.ico";